import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { getHabitsForDay } from "../../../../../utils/daily-accountability";

function PlanHabitsCard({ habits, dayKey }) {
  const { t } = useTranslation("athlete-portal");
  const dayHabits = getHabitsForDay(habits, dayKey);
  if (dayHabits.length === 0) return null;
  return (
    <div className="plan-card plan-card--habits">
      <div className="plan-card__header">
        <SvgIcon src="/img/new-icons/list-circle.svg" useCurrentColor={true} />
        {t("calendar.cards.habits.title")}
      </div>
      <div className="plan-card__body">
        {dayHabits.map((habit) => (
          <div key={habit._id} className="plan-card__habit-row">
            <span>{habit.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
export default PlanHabitsCard;
